// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"FundsTableRowSkeleton_skeleton__evugQ"};